<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>

          <!-- Header -->
          <template v-slot:headerTitle>
              <h4 class="card-title"> {{ $t('consultancy_therapy_center.service_recipients_registration_form') }}</h4>
          </template>

          <!-- Body -->
          <template v-slot:body>

            <!-- Patient Search Form -->
            <b-overlay :show="formLoader" v-if="!inEditMode">
              <b-row>
                <b-col xl="12" lg="12" sm="12">
                  <ValidationObserver ref="patientSearchForm"  v-slot="{ handleSubmit, reset }">
                      <b-form @submit.prevent="handleSubmit(handlePatientSearchForm)" @reset.prevent="reset">
                          <b-row>

                              <b-col sm="12" lg="6" xl="6">
                                <ValidationProvider name="Patient Type" vid="patient_type" rules="required|min_value:1">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="3"
                                          label-for="patient_type"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                          {{$t('consultancy_therapy_center.service_recipients')}} {{$t('globalTrans.type')}}<span class="text-danger">*</span>
                                      </template>
                                      <b-form-select
                                          plain
                                          v-model.number="patientSearchForm.patient_type"
                                          :options="patientTypeList"
                                          id="patient_type"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                      >
                                      <template v-slot:first>
                                          <!-- <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option> -->
                                      </template>
                                      </b-form-select>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                      </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col sm="12" lg="6" xl="6" v-if="patientSearchForm.patient_type === 1">
                                <ValidationProvider name="ID Type" vid="id_type" :rules="`${patientSearchForm.patient_type === 1 ? 'required|min_value:1' : ''}`">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="3"
                                          label-for="id_type"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                          {{$t('consultancy_therapy_center.id_type')}}<span class="text-danger">*</span>
                                      </template>
                                      <b-form-select
                                          plain
                                          v-model="patientSearchForm.id_type"
                                          :options="iDTypeList"
                                          id="id_type"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                      >
                                      <template v-slot:first>
                                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                      </template>
                                      </b-form-select>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                      </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col sm="12" lg="6" xl="6" v-if="patientSearchForm.patient_type === 1">
                                  <ValidationProvider name="Input ID" vid="input_id" :rules="`${patientSearchForm.patient_type === 1 ? 'required|max:50' : ''}`">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="3"
                                        label-for="input_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('consultancy_therapy_center.input_id')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="patientSearchForm.input_id"
                                        id="input_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                  </ValidationProvider>
                                </b-col>

                                <b-col sm="12" lg="6" xl="6" v-if="patientSearchForm.patient_type === 1">
                                  <b-button type="submit" id="button-1" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                                </b-col>
                          </b-row>
                      </b-form>
                  </ValidationObserver>
                </b-col>
              </b-row>
            </b-overlay>
            <!-- /Patient Search Form -->

            <!-- horizontal line -->
            <b-row v-if="!inEditMode">
              <b-col><hr></b-col>
            </b-row>

            <!-- Form -->
            <b-overlay :show="formLoader" v-show="patientSearchForm.patient_type === 2 || patientSearchForm.searchIsValid === true">
              <b-row>
                  <b-col lg="12" sm="12">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                    <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >

                      <b-row>
                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="ID Information" vid="id_information" rules="required|min_value:1">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="id_information"
                                slot-scope="{ valid, errors }"
                                  >
                                <template v-slot:label>
                                    {{ $t('consultancy_therapy_center.id_information')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="patient.id_information"
                                  :options="iDInformationList"
                                  id="id_information"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  @change="changeIdInformation($event)"
                                  :disabled="patientSearchForm.searchIsValid"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patient.id_information === 1">
                        <ValidationProvider name="NID No" vid="nid" :rules="`${patient.id_information === 1 ? 'required|max:17|min:10' : ''}`">
                                    <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="nid"
                                      slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                        {{ $t('consultancy_therapy_center.nid_no')}}
                                      </template>
                                      <b-form-input
                                        plain
                                        id="nid_no"
                                        v-model="patient.nid"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="patientSearchForm.searchIsValid"
                                        >
                                      </b-form-input>
                                      <div class="invalid-feedback">
                                        {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                            </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patient.id_information === 2">
                      <ValidationProvider name="Birth Registration No" vid="birth_registration_no" :rules="`${patient.id_information === 2 ? 'required' : ''}`">
                              <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="birth_registration_no"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{ $t('consultancy_therapy_center.birth_registration_no')}}
                                </template>
                                <b-form-input
                                  plain
                                  id="birth_reg_no"
                                  v-model="patient.birth_reg_no"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                                  >
                                </b-form-input>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                      </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 2">
                            <ValidationProvider name="Date of Birth" vid="date_of_birth" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="date_of_birth"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('externalUser.date_of_birth')}} <span class="text-danger">*</span>
                                </template>
                                <div class="input-group">
                                    <slot>
                                        <flat-pickr
                                            :config="{ maxDate: 'today' }"
                                            class="form-control disabled"
                                            v-model="patient.date_of_birth"
                                            id="date_of_birth"
                                            placeholder="Select Date"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        </flat-pickr>
                                    </slot>
<!-- <button v-if="patient.id_information === 1" type="button" :disabled ="nidButtonDisabled" @click="nidVerify()" style="border-radius: 0px !important" class="btn btn-outline-primary">{{ nid_verify_check === 0 ? $t('globalTrans.verify') : $t('globalTrans.verified')}}</button> -->
                                </div>
                                <div class="invalid-feedback d-block">
                                    {{ errors[0] }}
                                </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 1">
                        <ValidationProvider name="Date of Birth" vid="date_of_birth" rules="required">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="date_of_birth"
                                  slot-scope="{ valid, errors }"
                                >
                                  <template v-slot:label>
                                    {{ $t('consultancy_therapy_center.date_of_birth') }}<span class="text-danger">*</span>
                                  </template>
                                  <b-form-input
                                    id="date_of_birth"
                                    v-model="patient.date_of_birth"
                                    :placeholder="$t('consultancy_therapy_center.date_of_birth')"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="true"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 1">
                            <ValidationProvider name="Name (En)" vid="name" rules="required">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="name"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                      {{ $t('consultancy_therapy_center.name_en') }}<span class="text-danger">*</span>
                                    </template>
                                  <b-form-input
                                    plain
                                    id="name"
                                    v-model="patient.name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="patientSearchForm.searchIsValid"
                                    >
                                  </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                            </ValidationProvider>
                      </b-col>
                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 2">
                            <ValidationProvider name="Name (En)" vid="name" rules="required">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="name"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                      {{ $t('consultancy_therapy_center.name_en') }}<span class="text-danger">*</span>
                                    </template>
                                  <b-form-input
                                    plain
                                    id="name"
                                    v-model="patient.name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled ="nidDisabled"
                                    >
                                  </b-form-input>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                            </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 1">
                          <ValidationProvider name="Name (Bn)" vid="name_bn" rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="level"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.name_bn')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 2">
                          <ValidationProvider name="Name (Bn)" vid="name_bn" rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="level"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.name_bn')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled ="nidDisabled"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Age" vid="age" rules="required">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="age"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('consultancy_therapy_center.age')}}<span class="text-danger">*</span>
                                  </template>
                                  <b-form-input readonly
                                    plain
                                    id="age"
                                    v-model="patient.age"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="patientSearchForm.searchIsValid"
                                    >
                                  </b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="gender" vid="gender" rules="required|min_value:1">
                              <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="gender"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{ $t('consultancy_therapy_center.gender')}}<span class="text-danger">*</span>
                                </template>
                                      <b-form-select
                                        plain
                                        id="gender"
                                        v-model="patient.gender_id"
                                        :options="genderTypeList"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="patientSearchForm.searchIsValid"
                                        >
                                        <template v-slot:first>
                                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                      </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patient.id_information < 4">
                        <ValidationProvider name="Name (En)" vid="guardian_name" rules="required">
                          <b-form-group class="row" label-cols-sm="12" label-for="guardian_name"
                            slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.guardian_name_en')}}<span class="text-danger">*</span>
                            </template>
                            <b-form-input plain id="name_bn" v-model="patient.guardian_name"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid">
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 1 && patient.id_information < 4">
                        <ValidationProvider name="Name (Bn)" vid="guardian_name_bn" rules="required">
                          <b-form-group class="row" label-cols-sm="12" label-for="guardian_name_bn"
                            slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.guardian_name_bn')}}<span class="text-danger">*</span>
                            </template>
                            <b-form-input plain id="guardian_name_bn" v-model="patient.guardian_name_bn"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid">
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 2 && patient.id_information < 4">
                        <ValidationProvider name="Name (Bn)" vid="guardian_name_bn" rules="required">
                          <b-form-group class="row" label-cols-sm="12" label-for="guardian_name_bn"
                            slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.guardian_name_bn')}}<span class="text-danger">*</span>
                            </template>
                            <b-form-input plain id="guardian_name_bn" v-model="patient.guardian_name_bn"
                              :state="errors[0] ? false : (valid ? true : null)" :disabled="nidDisabled">
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="Name (En)" vid="guardian_name" rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="guardian_name"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.guardian_name_en')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.guardian_name"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" :hidden="patient.id_information === 1 ? true : false" v-if="patientSearchForm.patient_type === 1">
                          <ValidationProvider name="Name (Bn)" vid="guardian_name_bn" rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="guardian_name_bn"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.guardian_name_bn')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.guardian_name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col sm="12" lg="4" xl="4" :hidden="patient.id_information === 1 ? true : false" v-if="patientSearchForm.patient_type === 2">
                          <ValidationProvider name="Name (Bn)" vid="guardian_name_bn" rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="guardian_name_bn"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.guardian_name_bn')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.guardian_name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled ="nidDisabled"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col> -->

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Phone No" vid="mobile_no" rules="required|max:11|min:11">
                            <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="mobile_no"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.phone_no')}}<span class="text-danger">*</span>
                            </template>
                            <b-form-input
                              plain
                              id="mobile_no"
                              v-model="patient.mobile_no"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid"
                              >
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patient.id_information < 4">
                        <ValidationProvider name="Name (En)" vid="mother_name" rules="">
                          <b-form-group class="row" label-cols-sm="12" label-for="mother_name"
                            slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.mother_name_en') }}
                            </template>
                            <b-form-input plain id="name_bn" v-model="patient.mother_name"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid">
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 1 && patient.id_information < 4">
                        <ValidationProvider name="Name (Bn)" vid="mother_name_bn" rules="">
                          <b-form-group class="row" label-cols-sm="12" label-for="mother_name_bn"
                            slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.mother_name_bn') }}
                            </template>
                            <b-form-input plain id="mother_name_bn" v-model="patient.mother_name_bn"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid">
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col sm="12" lg="4" xl="4" v-if="patientSearchForm.patient_type === 2 && patient.id_information < 4">
                        <ValidationProvider name="Name (Bn)" vid="mother_name_bn" rules="">
                          <b-form-group class="row" label-cols-sm="12" label-for="mother_name_bn"
                            slot-scope="{ valid, errors }">
                            <template v-slot:label>
                              {{ $t('consultancy_therapy_center.mother_name_bn') }}
                            </template>
                            <b-form-input plain id="mother_name_bn" v-model="patient.mother_name_bn"
                              :state="errors[0] ? false : (valid ? true : null)" :disabled="nidDisabled">
                            </b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="Name (En)" vid="mother_name" rules="">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="mother_name"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.mother_name_en') }}
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.mother_name"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" :hidden="patient.id_information === 1 ? true : false" v-if="patientSearchForm.patient_type === 1">
                          <ValidationProvider name="Name (Bn)" vid="mother_name_bn" rules="">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="mother_name_bn"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.mother_name_bn') }}
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.mother_name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col sm="12" lg="4" xl="4" :hidden="patient.id_information === 1 ? true : false" v-if="patientSearchForm.patient_type === 2">
                          <ValidationProvider name="Name (Bn)" vid="mother_name_bn" rules="">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="mother_name_bn"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.mother_name_bn') }}
                              </template>
                              <b-form-input
                                plain
                                id="name_bn"
                                v-model="patient.mother_name_bn"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled ="nidDisabled"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                      </b-col> -->

                      <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="Upload Photo" vid="attachment" rules="">
                              <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="attachment"
                                  >
                                  <template v-slot:label>
                                      {{$t('consultancy_therapy_center.upload_phpto')}}
                                  </template>
                                  <b-form-file
                                    id="attachment"
                                    accept=".png, .jpg, .jpeg, .svg, .pdf, .doc, .docx, .tex, .txt, .rtf"
                                    v-model="uploadAttachment"
                                    v-on:change="onAttachmentChange"
                                    :disabled="patientSearchForm.searchIsValid"
                                  >
                                  </b-form-file>
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                    </b-row>

                    <!-- Address -->
                    <iq-card>
                        <template>
                          <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white text-center">
                                {{ $t('consultancy_therapy_center.address') }}
                            </h5>
                          </div>
                      </template>
                    </iq-card>

                    <b-row>
                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Area Type" vid="area_type_id" rules="required|min_value:1">
                            <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="area_type_id "
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                              plain
                              v-model="patient.area_type_id"
                              id="area_type_id"
                              :options="areaTypeList"
                              @change="getAreaTypeData(patient.area_type_id)"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid"
                            >
                            <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="division_id"
                                slot-scope="{ valid, errors }"
                                  >
                                <template v-slot:label>
                                    {{ $t('org_pro_division.division')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="patient.division_id"
                                  :options="divisionList"
                                  id="division_id"
                                  @change="changeDivisionId(patient.division_id)"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                                  >
                                  <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="district_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                  {{ $t('org_pro_district.district')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="patient.district_id"
                                    :options="districtList"
                                    id="district_id"
                                    @change="changeDistrictId(patient.district_id)"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="patientSearchForm.searchIsValid"
                                  >
                                  <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                      </div>
                                  </b-form-group>
                          </ValidationProvider>
                      </b-col>

                      <!-- City Corporation -->
                      <b-col sm="12" lg="4" xl="4" v-show="cityCorporationShow">
                        <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required|min_value:1' : ''}`">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="city_corporation_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{ $t('org_pro.city_corporation') }} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                v-model="patient.city_corporation_id"
                                :options="cityCorporationList"
                                id="city_corporation_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                                <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                      {{ errors[0] }}
                                </div>
                                </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Upazilla -->
                      <b-col sm="12" lg="4" xl="4" v-show="upazillaShow">
                          <ValidationProvider name="Upazilla" vid="upazilla_id" :rules="`${upazillaShow ? 'required|min_value:1' : ''}`">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="upazilla_id"
                                slot-scope="{ valid, errors }"
                                  >
                                <template v-slot:label>
                                {{ $t('org_pro_upazilla.upazilla')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="patient.upazilla_id"
                                  :options="upazillaList"
                                  id="upazilla_id"
                                  @change="changeUpazillaId(patient.upazilla_id)"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                                >
                                <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                          </ValidationProvider>
                      </b-col>

                      <!-- Pauroshoba -->
                      <b-col sm="12" lg="4" xl="4" v-show="pauroshobaShow">
                        <ValidationProvider name="Pauroshoba" vid="pauroshoba_id" :rules="`${pauroshobaShow ? 'required|min_value:1' : ''}`">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="pauroshoba_id"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{ $t('consultancy_therapy_center.pauroshoba') }} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="patient.pauroshoba_id"
                                  :options="pauroshobaList"
                                  id="pauroshoba_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                                  >
                                  <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <!-- Union -->
                      <b-col sm="12" lg="4" xl="4" v-show="unionShow">
                          <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="union_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{ $t('org_pro_union.union')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                v-model="patient.union_id"
                                :options="unionList"
                                id="union_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                                >
                                <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                          </ValidationProvider>
                      </b-col>

                      <b-col lg="4"  sm="12">
                          <ValidationProvider name="Address(En)" vid="address">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="address"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('consultancy_therapy_center.address_line_en')}}
                              </template>
                                  <b-form-textarea
                                  id="address"
                                  v-model="patient.address"
                                  rows="1"
                                  max-rows="2"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                                  ></b-form-textarea>
                                  <div class="invalid-feedback">
                                  {{ errors[0] }}
                                  </div>
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col lg="4"  sm="12">
                          <ValidationProvider name="Address(Bn)" vid="address_bn">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="address_bn"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('consultancy_therapy_center.address_line_bn')}}
                              </template>
                                  <b-form-textarea
                                  id="address_bn"
                                  v-model="patient.address_bn"
                                  rows="1"
                                  max-rows="2"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                                  ></b-form-textarea>
                                  <div class="invalid-feedback">
                                  {{ errors[0] }}
                                  </div>
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                    </b-row>
                    <!-- /Address -->

                    <!-- Application Information -->
                    <iq-card v-if="!inEditMode">
                        <template>
                          <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white text-center">
                                {{ $t('consultancy_therapy_center.application_information') }}
                            </h5>
                          </div>
                      </template>
                    </iq-card>

                    <b-row v-if="!inEditMode">
                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Center Type" vid="center_type" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="level"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('consultancy_therapy_center.center_type')}}<span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    id="center_type"
                                    v-model="patient.center_type"
                                    :options="centerTypeList"
                                    @change="changeCenterType($event)"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patient.center_type == 1">
                        <ValidationProvider name="Center" vid="therapy_center_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="level"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.therapy_center')}}<span class="text-danger">*</span>
                              </template>
                              <v-select
                              name="center" v-model="patient.therapy_center_id" label="text" :reduce="item => item.value"
                               :options=therapyCenterList :placeholder="$t('globalTrans.select')" :filter-by="myFilter" :state="errors[0] ? false : (valid ? true : null)" />
                               <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if="patient.center_type == 2">
                        <ValidationProvider name="campaign" vid="campaign_id" rules="required|min_value:1">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="level"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.campaign')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-select
                                plain
                                id="campaign_id"
                                v-model="patient.campaign_id"
                                :options="campaignCenterList"
                                @change="changeCampaign($event)"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4" v-if = "$route.query.id === undefined">
                      <ValidationProvider name="Application Date" vid="application_date" rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="level"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.application_date')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-input
                                plain
                                id="application_date_picker"
                                v-model="patient.application_date"
                                :placeholder="$t('consultancy_therapy_center.application_date')"
                                :state="errors[0] ? false : (valid ? true : null)"
                                @change="checkApplicationDateOver"
                                >
                              </b-form-input>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                      </ValidationProvider>
                      </b-col>
                    </b-row>
                    <!-- /Application Information -->

                    <!-- Disability
                    <iq-card>
                        <template>
                          <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white text-center">
                                {{ $t('consultancy_therapy_center.disability_information') }}
                            </h5>
                          </div>
                      </template>
                    </iq-card>-->

                    <b-row>
                      <!--<b-col sm="12" lg="12" xl="12">
                        <ValidationProvider name="Disability Information" vid='is_disabled' rules="required">
                            <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="is_disabled"
                              slot-scope="{ valid, errors }"
                            >
                              <template v-slot:label>
                                  {{ $t('consultancy_therapy_center.disability_information') }} <span class="text-danger">*</span>
                              </template>
                              <b-form-radio-group
                                v-model="patient.is_disabled"
                                :options="disabilityInformationList"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                              ></b-form-radio-group>
                              <div class="invalid-feedback d-block">
                                  {{ errors[0] }}
                              </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="12" xl="12">
                        <ValidationProvider name="Disability Types" vid="disability_types" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('consultancy_therapy_center.patient_disability_type')"
                            label-for="disability_types"
                            slot-scope="{ valid, errors }"
                          >
                            <b-form-checkbox-group
                              v-model="patient.disability_types"
                              :options="disabilityTypesList"
                              :state="errors[0] ? false : (valid ? true : null)"
                              :disabled="patientSearchForm.searchIsValid"
                            ></b-form-checkbox-group>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>-->

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="DSS PWD ID No" vid="pwd_no" rules="">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="level"
                                  slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('consultancy_therapy_center.dss_pwd_id_no') }}
                                  </template>
                                  <b-form-input
                                    plain
                                    id="pwd_no"
                                    v-model="patient.pwd_no"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="patientSearchForm.searchIsValid"
                                    >
                                  </b-form-input>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Issue Date" vid="issue_date" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="issue_date"
                                  slot-scope="{ valid, errors }"
                                >
                                  <template v-slot:label>
                                    {{ $t('consultancy_therapy_center.issue_date') }}
                                  </template>
                                  <b-form-input
                                    id="issue_date_picker"
                                    v-model="patient.issues_date"
                                    :placeholder="$t('consultancy_therapy_center.issue_date')"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <!-- /Disability -->

                    <!-- Other Information -->
                    <iq-card>
                        <template>
                          <div style="font-size:18px; background-color: #005B5B;">
                            <h5 class="text-white text-center">
                                {{ $t('consultancy_therapy_center.other_information') }}
                            </h5>
                          </div>
                      </template>
                    </iq-card>

                    <b-row>
                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Educational Qualification" vid="educational_qualification" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="educational_qualification"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                  {{$t('consultancy_therapy_center.educational_qualification')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="patient.educational_qualification"
                                  :options="educationalQualificationList"
                                  id="educational_qualification"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                              >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Profession/Occupation" vid="occupation" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="occupation"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                  {{$t('consultancy_therapy_center.occupation')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="patient.occupation"
                                  :options="occupationList"
                                  id="occupation"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                              >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Number of Family Members" vid="no_family_members" rules="between:1,20">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="no_family_members"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                  {{$t('consultancy_therapy_center.no_family_members')}}
                              </template>
                              <b-form-input
                                class="form-control"
                                v-model.number="patient.no_family_members"
                                id="no_family_members"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                              ></b-form-input>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Number of Earning Members in Family" vid="no_earning_members" rules="between:1,20">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="no_earning_members"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                  {{$t('consultancy_therapy_center.no_earning_members')}}
                              </template>
                              <b-form-input
                                class="form-control"
                                v-model.number="patient.no_earning_members"
                                id="no_earning_members"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"
                              ></b-form-input>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Type of House Living In" vid="type_house" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="type_house"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                  {{$t('consultancy_therapy_center.type_house')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="patient.type_house"
                                  :options="typeHouseList"
                                  id="type_house"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                              >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                        <ValidationProvider name="Monthly income of the Family" vid="family_monthly_income" rules="">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                  label-for="family_monthly_income"
                                  slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                                  {{$t('consultancy_therapy_center.family_monthly_income')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="patient.family_monthly_income"
                                  :options="monthlyIncomeList"
                                  id="family_monthly_income"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="patientSearchForm.searchIsValid"
                              >
                              <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                              </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col sm="12" lg="4" xl="4">
                          <ValidationProvider name="Reason" vid="reason_id" rules="required|min_value:1">
                            <b-form-group class="row" label-cols-sm="12" label-for="reason_id"
                              slot-scope="{ valid, errors }">
                              <template v-slot:label>
                                {{$t('consultancy_therapy_center.reason_visit')}}<span class="text-danger">*</span>
                              </template>
                              <b-form-select plain v-model="patient.reason_id" :options="reasonList" id="reason_id"
                                :state="errors[0] ? false : (valid ? true : null)">
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>

                        <b-col sm="12" lg="12" xl="12" v-if="patient.reason_id === 4">
                          <ValidationProvider name="Reason" vid="reason_visit" rules="">
                            <b-form-group class="row" label-cols-sm="12" label-for="reason_visit"
                              slot-scope="{ valid, errors }">
                              <template v-slot:label>
                                {{ $t('consultancy_therapy_center.other_reason') }}
                              </template>
                              <b-form-textarea id="reason_visit" v-model="patient.reason_visit" rows="4" max-rows="4"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="patientSearchForm.searchIsValid"></b-form-textarea>
                              <div class="invalid-feedback">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    <!-- /Other Information -->

                    <!-- Save -->
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2" :disabled="saveButtonDisabled">{{ saveBtnName }}</b-button>
                        &nbsp;
                        <b-button variant="danger" class="mr-1">
                          <router-link :class="'text-light'" :to="{ path: '/portal/disability-service-panel'}" size="sm">
                            {{ $t('globalTrans.cancel') }}
                          </router-link>
                        </b-button>
                      </div>
                    </div>
                    <!-- /Save -->

                  </b-form>
                  </ValidationObserver>
                </b-col>
              </b-row>
            </b-overlay>
            <!-- /Form -->

          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl, authServiceBaseUrl } from '@/config/api_config'
import { portalPatientRegistrationStoreApi, portalPatientRegistrationUpdateApi, portalPatientGetRegisteredPatientApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id', 'item'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      /** Address */
        cityCorporationShow: false,
        upazillaShow: false,
        unionShow: false,
        pauroshobaShow: false,
        nidButtonDisabled: true,
        nidDisabled: false,
      /** Patient Search Form */
      patientSearchForm: {
        /** Patient Type 2=New From The Get-go */
        patient_type: 2,
        id_type: 0,
        input_id: '',
        searchIsValid: false
      },
      /** Patient */
      patient: {
        /** Registration */
        auth: authServiceBaseUrl,
        patient_type: 0,
        id: 0,
        name: '',
        name_bn: '',
        area_type_id: 0,
        city_corporation_id: 0,
        pauroshoba_id: 0,
        country_id: 0,
        division_id: 0,
        district_id: 0,
        upazilla_id: 0,
        union_id: 0,
        ward_id: 0,
        address: '',
        address_bn: '',
        gender_id: 0,
        mobile_no: '',
        profession: '',
        profession_bn: '',
        family_income: '',
        date_of_birth: '',
        age: '',
        id_information: 0,
        nid: '',
        birth_reg_no: '',
        dss_id_no: '',
        guardian_name: '',
        guardian_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        registration_no: '',
        educational_qualification: 0,
        occupation: 0,
        no_family_members: '',
        no_earning_members: '',
        type_house: 0,
        family_monthly_income: 0,
        reason_visit: '',
        pwd_no: '',
        issues_date: '',
        attachment: '',
        has_updated_attachment: 0,

        is_disabled: 0,
        // disability_types: [],

        /** Application */
        center_type: 0,
        therapy_center_id: null,
        campaign_id: 0,
        application_no: '',
        application_date: '',
        reason_id: 0
      },

      saveBtnName: this.$route.query.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),

      districtList: [],
      cityCorporationList: [],
      upazillaList: [],
      unionList: [],
      pauroshobaList: [],
      /** */
      formLoader: false,
      saveButtonDisabled: false,
      inEditMode: false,
      request_number: 1,
      nid_verify_check: 0,
      uploadAttachment: []
    }
  },
  created () {
    /** */
    if (this.$route.query.id) {
      const tmp = this.getPatientDataFromStore()
      if (tmp) {
        /** Edit Mode */
        this.inEditMode = true

        this.patient.id = tmp.id
        this.patient.name = tmp.name
        this.patient.name_bn = tmp.name_bn
        this.patient.area_type_id = tmp.area_type_id
        this.patient.city_corporation_id = tmp.city_corporation_id
        this.patient.pauroshoba_id = tmp.pauroshoba_id
        this.patient.country_id = tmp.country_id
        this.patient.division_id = tmp.division_id
        this.patient.district_id = tmp.district_id
        this.patient.upazilla_id = tmp.upazilla_id
        this.patient.union_id = tmp.union_id
        this.patient.ward_id = tmp.ward_id
        this.patient.address = tmp.address
        this.patient.address_bn = tmp.address_bn
        this.patient.gender_id = tmp.gender_id
        this.patient.mobile_no = tmp.mobile_no
        this.patient.profession = tmp.profession
        this.patient.profession_bn = tmp.profession_bn
        this.patient.family_income = tmp.family_income
        this.patient.date_of_birth = tmp.date_of_birth
        this.patient.age = tmp.age
        this.patient.id_information = tmp.id_information
        this.patient.nid = tmp.nid
        this.patient.birth_reg_no = tmp.birth_reg_no
        this.patient.dss_id_no = tmp.dss_id_no
        this.patient.guardian_name = tmp.guardian_name
        this.patient.guardian_name_bn = tmp.guardian_name_bn
        this.patient.mother_name = tmp.mother_name
        this.patient.mother_name_bn = tmp.mother_name_bn
        this.patient.registration_no = tmp.registration_no
        this.patient.educational_qualification = tmp.educational_qualification
        this.patient.occupation = tmp.occupation
        this.patient.no_family_members = tmp.no_family_members ?? ''
        this.patient.no_earning_members = tmp.no_earning_members ?? ''
        this.patient.type_house = tmp.type_house
        this.patient.family_monthly_income = tmp.family_monthly_income
        this.patient.reason_visit = tmp.reason_visit
        this.patient.pwd_no = tmp.pwd_no
        this.patient.issues_date = tmp.issues_date ?? ''
        this.patient.attachment = tmp.attachment

        this.patient.is_disabled = tmp.is_disabled
        // this.patient.disability_types = tmp.disability_types.map(item => item.disability_id)

        this.fillFormWithAreaTypeData(tmp.area_type_id)
      }
    }
    if (this.patient.nid) {
        // this.nidDisabled = true
        this.nidDisabled = false
        this.nidButtonDisabled = true
    }
  },
  mounted () {
    if (window.jQuery) {
      window.jQuery('#name_bn').bangla({ enable: true })
      window.jQuery('#guardian_name_bn').bangla({ enable: true })
      window.jQuery('#mother_name_bn').bangla({ enable: true })
      window.jQuery('#address_bn').bangla({ enable: true })
    }
    flatpickr('#date_of_birth', {})
    flatpickr('#issue_date_picker', {})
    flatpickr('#application_date_picker', {})
  },
  computed: {
      iDTypeList: function () {
          return [
            { value: 1, text: this.$i18n.locale === 'en' ? 'Registration No' : 'রেজিস্ট্রেশন নম্বর' },
            { value: 2, text: this.$i18n.locale === 'en' ? 'Phone No' : 'ফোন নম্বর' },
            { value: 3, text: this.$i18n.locale === 'en' ? 'NID' : 'এনআইডি' }
          ]
      },
      patientTypeList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.patientTypeList
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
          })
      },
      reasonList: function () {
        const objectData = this.$store.state.ExternalUser.commonObj.reasonList
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
          })
      },
      areaTypeList: function () {
          const objectData = this.$store.state.ExternalUser.commonObj.wardTypeList
          return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.id, text: obj.name_bn }
              } else {
                  return { value: obj.id, text: obj.name }
              }
          })
      },
      disabilityTypesList: function () {
        return this.$store.state.ExternalUser.hospitalCommonObj.disabilityTypesList
      },
      centerTypeList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.centerTypeList
        return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text_en }
              }
          })
      },
      divisionList: function () {
          return this.$store.state.ExternalUser.commonObj.divisionList.filter(item => item.status === 0)
      },
      genderTypeList: function () {
        const objectData = this.$store.state.ExternalUser.commonObj.genderList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      },
      therapyCenterList: function () {
        return this.$store.state.ExternalUser.hospitalCommonObj.therapyCenterList.filter(item => item.status === 1 && item.sales_center_type === 1)
      },
      campaignCenterList: function () {
        return this.$store.state.ExternalUser.hospitalCommonObj.campaignCenterList.filter(item => item.status === 1)
      },
      educationalQualificationList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.educationalQualificationList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      },
      occupationList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.occupationList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      },
      typeHouseList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.typeHouseList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      },
      monthlyIncomeList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.monthlyIncomeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      },
      iDInformationList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.iDInformationList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      },
      disabilityInformationList: function () {
        const objectData = this.$store.state.ExternalUser.hospitalCommonObj.disabilityInformationList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      }
    },
  watch: {
    'patientSearchForm.patient_type': function (newVal, oldVal) {
      if (newVal === 1) {
        /** Patient Type 1=Registered */
        this.patientSearchForm.searchIsValid = false
      } else if (newVal === 2) {
        /** Patient Type 2=New */
        this.patientSearchForm.searchIsValid = false
        this.patientSearchForm.id_type = 0
        this.patientSearchForm.input_id = ''
        if (this.patient.id > 0) this.resetForm()
      }
    },
    'patient.date_of_birth': function (newVal, oldVal) {
      this.calculateAge()
    },
    'patient.id_information': function (newVal, oldVal) {
      if (newVal === 1) {
// this.nidDisabled = true
          this.nidDisabled = false
          this.nidButtonDisabled = false
      } else {
          this.nidDisabled = false
          this.nidButtonDisabled = false
      }
    }
  },
  methods: {
    myFilter: (option, text, search) => {
            const temp = search.toLowerCase()
            return option.text_en.toLowerCase().indexOf(temp) > -1 ||
                option.text_bn.toLowerCase().indexOf(temp) > -1
        },
    async nidVerify () {
        this.unitLoad = true
        const requestData = {
            component_id: 4,
            module_id: 0,
            service_id: 0,
            menu_id: 0,
            date_of_birth: this.patient.date_of_birth,
            nid: this.patient.nid,
            request_number: this.request_number
        }
        let result = null
        result = await RestApi.postData(authServiceBaseUrl, 'nid/voter-details-with', requestData)
        if (result.success) {
            const data = result.data
            this.nid_verify_check = 1
            this.patient.name_bn = data.name
            this.patient.name = data.nameEn
            if (result.ourDB) {
                this.request_number = 2
            }
            if (!result.ourDB) {
                this.nidDisabled = true
                this.nidButtonDisabled = true
            }
            this.patient.guardian_name_bn = 'N/A'
            this.patient.mother_name_bn = 'N/A'
            this.unitLoad = false
        } else {
            this.patient.name_bn = ''
            this.patient.name = ''
            this.patient.guardian_name_bn = ''
            this.patient.mother_name_bn = ''
            this.$toast.error({
              title: this.$t('globalTrans.error'),
              message: this.$t('globalTrans.nid_error'),
              color: '#D6E09B'
            })
            this.unitLoad = false
        }
    },
    resetForm () {
      this.patient.id = 0
      this.patient.name = ''
      this.patient.name_bn = ''
      this.patient.area_type_id = 0
      this.patient.city_corporation_id = 0
      this.patient.pauroshoba_id = 0
      this.patient.country_id = 0
      this.patient.division_id = 0
      this.patient.district_id = 0
      this.patient.upazilla_id = 0
      this.patient.union_id = 0
      this.patient.ward_id = 0
      this.patient.address = ''
      this.patient.address_bn = ''
      this.patient.gender_id = 0
      this.patient.mobile_no = ''
      this.patient.profession = ''
      this.patient.profession_bn = ''
      this.patient.family_income = ''
      this.patient.date_of_birth = ''
      this.patient.age = ''
      this.patient.id_information = 0
      this.patient.nid = ''
      this.patient.birth_reg_no = ''
      this.patient.dss_id_no = ''
      this.patient.guardian_name = ''
      this.patient.guardian_name_bn = ''
      this.patient.mother_name = ''
      this.patient.mother_name_bn = ''
      this.patient.registration_no = ''
      this.patient.educational_qualification = 0
      this.patient.occupation = 0
      this.patient.no_family_members = ''
      this.patient.no_earning_members = ''
      this.patient.type_house = 0
      this.patient.family_monthly_income = 0
      this.patient.reason_visit = ''
      this.patient.pwd_no = ''
      this.patient.issues_date = ''
      this.patient.attachment = []

      this.patient.is_disabled = 0
      // this.patient.disability_types = []

      document.getElementById('date_of_birth').flatpickr().clear()
      document.getElementById('issue_date_picker').flatpickr().clear()

      this.fillFormWithAreaTypeData(0)
    },
    getAreaTypeData (typeId) {
      /**
       * 1 - City Corporation (City-Coporation, Ward)
       * 2 - Pauroshoba (Upazilla, Pourosoba, Ward)
       * 3 - Union (Upazilla, Pourosoba, Ward)
       */
      if (typeId === 1) {
        /** City Corporation */
        this.patient.city_corporation_id = 0
        this.patient.upazilla_id = 0
        this.patient.pauroshoba_id = 0
        this.patient.union_id = 0
        this.patient.ward_id = 0
        this.cityCorporationShow = true
        this.upazillaShow = false
        this.pauroshobaShow = false
        this.unionShow = false
      } else if (typeId === 2) {
        /** Pauroshoba */
        this.patient.city_corporation_id = 0
        this.patient.upazilla_id = 0
        this.patient.pauroshoba_id = 0
        this.patient.union_id = 0
        this.patient.ward_id = 0
        this.cityCorporationShow = false
        this.upazillaShow = true
        this.pauroshobaShow = true
        this.unionShow = false
      } else if (typeId === 3) {
        /** Union */
        this.patient.city_corporation_id = 0
        this.patient.upazilla_id = 0
        this.patient.pauroshoba_id = 0
        this.patient.union_id = 0
        this.patient.ward_id = 0
        this.cityCorporationShow = false
        this.upazillaShow = true
        this.pauroshobaShow = false
        this.unionShow = true
      } else {
        // Resetting The Form & Data
        this.patient.city_corporation_id = 0
        this.patient.upazilla_id = 0
        this.patient.pauroshoba_id = 0
        this.patient.union_id = 0
        this.patient.ward_id = 0
        this.cityCorporationShow = false
        this.upazillaShow = false
        this.pauroshobaShow = false
        this.unionShow = false
      }
      /** Upadting List - cityCorporationList & upazillaList */
      this.cityCorporationList = this.getCityCorporationList(this.patient.district_id)
      this.upazillaList = this.getUpazillaList(this.patient.district_id)
    },
    checkApplicationDateOver () {
      if (this.patient.center_type === 2 && this.patient.campaign_id >= 1 && this.patient.application_date) {
        const campaign = this.$store.state.ExternalUser.hospitalCommonObj.campaignCenterList.find(item => item.value === this.patient.campaign_id)
        const applicationDate = new Date(this.patient.application_date)
        const campaignDate = new Date(campaign.campaign_date)
        if (campaignDate < applicationDate) {
          this.saveButtonDisabled = true
          this.$toast.error({ title: 'Error', message: 'Campaign date exceeded. You can not register now.' })
        } else {
          this.$toast.success({ title: 'Success', message: 'Valid Application date. You can register now.' })
          this.saveButtonDisabled = false
        }
      }
    },
    calculateAge () {
      if (this.patient.date_of_birth === null || this.patient.date_of_birth === '') { return false }
      const date1 = new Date()
      const dat2 = this.patient.date_of_birth
      const date2 = new Date(dat2)
      const oneYear = 24 * 60 * 60 * 1000 * 365 // hours*minutes*seconds*milliseconds
      const diffDays = Math.abs((date1.getTime() - date2.getTime()) / (oneYear))
      this.patient.age = parseInt(diffDays)
    },
    getDistrictList (divisionId = null) {
      return this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
    },
    getCityCorporationList (districtId = null) {
      return this.$store.state.ExternalUser.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getUpazillaList (districtId = null) {
      return this.$store.state.ExternalUser.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getUnionList (upazillaId = null) {
      return this.$store.state.ExternalUser.commonObj.unionList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
    },
    getPauroshobaList (upazillaId = null) {
      return this.$store.state.ExternalUser.commonObj.pauroshobaList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
    },
    /**
     * Attachment Upload
     */
    onAttachmentChange (e) {
      this.patient.attachment = e.target.files[0]
      if (this.inEditMode) {
        this.patient.has_updated_attachment = 1
      }
    },
    /** Fill Form With Area Type Data */
    fillFormWithAreaTypeData (typeId) {
        this.districtList = this.getDistrictList(this.patient.division_id)
        this.cityCorporationList = this.getCityCorporationList(this.patient.district_id)
        this.upazillaList = this.getUpazillaList(this.patient.district_id)

        if (typeId === 1) {
            /** City Corporation */
            this.cityCorporationShow = true
            this.upazillaShow = false
            this.unionShow = false
            this.pauroshobaShow = false
            this.cityCorporationList = this.getCityCorporationList(this.patient.district_id)
        } else if (typeId === 2) {
            /** Pauroshoba */
            this.cityCorporationShow = false
            this.upazillaShow = true
            this.unionShow = false
            this.pauroshobaShow = true
            this.upazillaList = this.getUpazillaList(this.patient.district_id)
            this.pauroshobaList = this.getPauroshobaList(this.patient.upazilla_id)
        } else if (typeId === 3) {
            /** Union */
            this.cityCorporationShow = false
            this.upazillaShow = true
            this.unionShow = true
            this.pauroshobaShow = false
            this.upazillaList = this.getUpazillaList(this.patient.district_id)
            this.unionList = this.getUnionList(this.patient.upazilla_id)
        } else {
          /** Zero */
          this.cityCorporationShow = false
          this.upazillaShow = false
          this.unionShow = false
          this.pauroshobaShow = false
          this.cityCorporationList = []
          this.upazillaList = []
          this.unionList = []
        }
    },
    /**
     * @change methods
     */
    changeIdInformation (idInformation) {
      if (idInformation === 0 || idInformation === 3) {
        this.patient.nid = this.patient.birth_reg_no = ''
      } else if (idInformation === 1) {
        this.patient.birth_reg_no = ''
      } else if (idInformation === 2) {
        this.patient.nid = ''
      }
    },
    changeCenterType (centerTypeId) {
      if (centerTypeId === 0) {
        // Reset
        this.patient.therapy_center_id = null
        this.patient.campaign_id = 0
      } else if (centerTypeId === 1) {
        // PSOSK Center
        this.patient.campaign_id = 0
      } else if (centerTypeId === 2) {
        // MTV Center
        this.patient.therapy_center_id = null
      }
    },
    changeCampaign (campaignId) {
      /**
       * The Goal here is to reset the application date
       * When a campaign is selected, have to check Application Date Over
       * */
      if (campaignId >= 1) {
        // Important Note! flatpickr().clear() fires @change="checkApplicationDateOver"
        this.patient.application_date = null
        document.getElementById('application_date_picker').flatpickr().clear()
        // document.getElementById('application_date').flatpickr({ minDate: 'today' })
      }
    },
    changeDivisionId (divisionId) {
      this.patient.district_id = 0
      this.districtList = this.getDistrictList(divisionId)
    },
    changeDistrictId (districtId) {
      this.patient.city_corporation_id = 0
      this.patient.upazilla_id = 0
      this.cityCorporationList = this.getCityCorporationList(districtId)
      this.upazillaList = this.getUpazillaList(districtId)
      /** Reset Center */
      // this.patient.therapy_center_id = null
    },
    changeUpazillaId (upazillaId) {
      this.patient.pauroshoba_id = 0
      this.patient.union_id = 0
      this.pauroshobaList = this.getPauroshobaList(upazillaId)
      this.unionList = this.getUnionList(upazillaId)
    },
    getPatientDataFromStore () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.$route.query.id))
      return tmpData ? JSON.parse(JSON.stringify(tmpData)) : null
    },
    /**
     * Asynchronous
     */
    async handlePatientSearchForm () {
      if (this.patientSearchForm.patient_type !== 1 && this.$route.query.id !== undefined) return false

      this.formLoader = true
      const result = await RestApi.getData(hospitalServiceBaseUrl, portalPatientGetRegisteredPatientApi, this.patientSearchForm)
      this.formLoader = false

      if (!result.success) {
        const errors = { input_id: ['Input ID is not valid.'] }
        this.$refs.patientSearchForm.setErrors(errors)
        this.patientSearchForm.searchIsValid = this.formLoader = false
        return false
      }

      if (result.success) {
        this.patient.id = result.data.id
        this.patient.name = result.data.name
        this.patient.name_bn = result.data.name_bn
        this.patient.area_type_id = result.data.area_type_id
        this.patient.city_corporation_id = result.data.city_corporation_id
        this.patient.pauroshoba_id = result.data.pauroshoba_id
        this.patient.country_id = result.data.country_id
        this.patient.division_id = result.data.division_id
        this.patient.district_id = result.data.district_id
        this.patient.upazilla_id = result.data.upazilla_id
        this.patient.union_id = result.data.union_id
        this.patient.ward_id = result.data.ward_id
        this.patient.address = result.data.address
        this.patient.address_bn = result.data.address_bn
        this.patient.gender_id = result.data.gender_id
        this.patient.mobile_no = result.data.mobile_no
        this.patient.profession = result.data.profession
        this.patient.profession_bn = result.data.profession_bn
        this.patient.family_income = result.data.family_income
        this.patient.date_of_birth = result.data.date_of_birth
        this.patient.age = result.data.age
        this.patient.id_information = result.data.id_information
        this.patient.nid = result.data.nid
        this.patient.birth_reg_no = result.data.birth_reg_no
        this.patient.dss_id_no = result.data.dss_id_no
        this.patient.guardian_name = result.data.guardian_name
        this.patient.guardian_name_bn = result.data.guardian_name_bn
        this.patient.mother_name = result.data.mother_name
        this.patient.mother_name_bn = result.data.mother_name_bn
        this.patient.registration_no = result.data.registration_no
        this.patient.educational_qualification = result.data.educational_qualification
        this.patient.occupation = result.data.occupation
        this.patient.no_family_members = result.data.no_family_members
        this.patient.no_earning_members = result.data.no_earning_members
        this.patient.type_house = result.data.type_house
        this.patient.family_monthly_income = result.data.family_monthly_income
        this.patient.reason_visit = result.data.reason_visit
        this.patient.pwd_no = result.data.pwd_no
        this.patient.issues_date = result.data.issues_date
        this.patient.attachment = result.data.attachment

        this.patient.is_disabled = result.data.is_disabled
        // this.patient.disability_types = result.data.disability_types.map(item => item.disability_id)

        document.getElementById('date_of_birth').flatpickr().setDate(this.patient.date_of_birth)
        document.getElementById('issue_date_picker').flatpickr().setDate(this.patient.issues_date)

        this.fillFormWithAreaTypeData(this.patient.area_type_id)

        this.patientSearchForm.searchIsValid = true
      }
    },
    async saveData () {
      this.formLoader = true
      let result = null

      const formData = new FormData()
      Object.keys(this.patient).map(key => {
        formData.set(key, this.patient[key])
      })
      formData.set('patient_type', this.patientSearchForm.patient_type)

      /** Passing An Array formData - https://stackoverflow.com/a/63396462 */
      // formData.set('disability_types', 'disability_types[]')
      // this.patient.disability_types.forEach((item) => formData.append('disability_types[]', item))

      if (this.$route.query.id && this.inEditMode) {
        formData.append('_method', 'PUT')
        result = await RestApi.postData(hospitalServiceBaseUrl, `${portalPatientRegistrationUpdateApi}/${this.$route.query.id}`, formData)
      } else {
        result = await RestApi.postData(hospitalServiceBaseUrl, portalPatientRegistrationStoreApi, formData)
      }

      this.formLoader = false

      if (result.success) {
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.$route.query.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })

        this.$router.push({ path: '/portal/disability-service-panel' })
      } else {
        this.$refs.form.setErrors(result.errors)
        this.$toast.error({
          title: 'Error',
          message: result.message
        })
      }
    }
  }
}

/**
 * • created
 * • resetForm
 * • handlePatientSearchForm
 *
 * this.patient.disability_types =
 */
</script>
<style>
  .list_style {
    list-style-type: square !important
  }
</style>
